import clientSetCookie from './clientSetCookie';
export const clientSetCookieWithMidnightExpiry = (name, value, options = {})=>{
    clientSetCookie(name, value, {
        ...options,
        expires: new Date(new Date().setHours(23, 59, 59))
    });
};
export default clientSetCookieWithMidnightExpiry;
